<template>
  <div class="flow-detail">
    <transition name="slide-fade">
      <TheDetail ref="theDetail" :add-form="addForm" :disabled="web === 'detail'" :pics="pics">
        <template v-slot:button="{ form }">
          <el-button
            v-permissions="'transfer:add'"
            type="primary"
            size="small"
            class="save"
            v-if="!addForm.id && $route.name === 'FlowDetail'"
            @click="addSave(form)"
            >保存
          </el-button>
          <el-button
            v-permissions="'transfer:update'"
            type="primary"
            size="small"
            class="save"
            v-if="addForm.id && web != 'detail' && $route.name === 'FlowDetail'"
            @click="editSave(form)"
            >保存
          </el-button>
          <el-button type="primary" size="small" plain class="cancel" @click="cancel">返回</el-button>
        </template>
      </TheDetail>
    </transition>
  </div>
</template>

<script>
import cityData from '../../utils/Data'
import TheDetail from './components/TheDetail.vue'

export default {
  name: 'Detail',
  components: {
    TheDetail: TheDetail
  },
  data() {
    return {
      userInfo: {},
      titles: ['客户中心'],
      web: '',
      addForm: {
        id: '',
        companyName: '',
        comNum: '',
        ignoreWord: '',
        infoType: '',
        establishmentTime: '',
        registeredCapital: '',
        address: '',
        province: '',
        city: '',
        county: '',
        taxNature: '',
        transferPrice: '',
        linkman: '',
        phone: '',
        natureBusiness: '',
        isPublic: '',
        industries: [],
        industrie: []
      },
      pics: [],
      industries: [],
      taxs: [
        { code: '1', name: '小规模' },
        { code: '2', name: '一般纳税人' }
      ],
      options: [],
      options1: cityData,
      picJdcmp: { src: '', file: '', name: '图片' },
      popupShowState: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2099, 0, 1),
      drawer: false,
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        ignoreWord: [{ required: true, message: '请输入忽略词', trigger: 'blur' }],
        infoType: [{ required: true, message: '请输入信息类型', trigger: 'blur' }],
        establishmentTime: [{ required: true, message: '请选择公司创建时间', trigger: 'change' }],
        registeredCapital: [{ required: true, message: '请输入注册资金', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        province: [{ required: true, message: '请输入省', trigger: 'change' }],
        city: [{ required: true, message: '请输入市', trigger: 'change' }],
        county: [{ required: true, message: '请输入县（区）', trigger: 'change' }],
        taxNature: [{ required: true, message: '请选择纳税性质', trigger: 'blur' }],
        transferPrice: [{ required: true, message: '请输入转让价格', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        linkman: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        natureBusiness: [{ required: true, message: '请输入警营范围', trigger: 'blur' }],
        isPublic: [{ required: true, message: '请选择是否上架', trigger: 'change' }],
        industrie: [{ required: true, message: '请选择行业', trigger: 'change' }]
      }
    }
  },
  methods: {
    /**
      查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.cycle = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },

    // 查询详情
    queryDetail() {
      const param = {
        id: this.$route.params.id
      }
      let url = ''
      if (this.$route.name === 'FlowDetail') {
        url = '/flow/detail'
      } else {
        url = '/flowOut/detail'
      }
      this.$get(url, param).then(
        result => {
          if (result.status === 200) {
            this.detailInfo = result.data
            for (const i in this.detailInfo.flow) {
              this.addForm[i] = this.detailInfo.flow[i]
            }
            this.pics = result.data.pics
            this.addForm.industries = result.data.industries
            for (let i = 0; i < result.data.industries.length; i++) {
              this.addForm.industrie.push(result.data.industries[i].industry)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增保存
    addSave(name) {
      console.log(name)
      this.$refs.theDetail.$refs[name].validate(valid => {
        if (valid) {
          const param = {
            companyName: this.addForm.companyName,
            comNum: this.addForm.comNum,
            ignoreWord: this.addForm.ignoreWord,
            infoType: this.addForm.infoType,
            establishmentTime: this.$common.timeFormat(
              new Date(this.addForm.establishmentTime.replace(/\-/g, '/')),
              'yyyy-MM-dd'
            ),
            registeredCapital: this.addForm.registeredCapital,
            address: this.addForm.address,
            province: this.addForm.province,
            city: this.addForm.city,
            county: this.addForm.county,
            taxNature: this.addForm.taxNature,
            transferPrice: this.addForm.transferPrice,
            phone: this.addForm.phone,
            linkman: this.addForm.linkman,
            natureBusiness: this.addForm.natureBusiness,
            isPublic: this.addForm.isPublic,
            pic: this.pics,
            industries: this.addForm.industrie
          }
          this.$post('/flow/submit', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.cancel()
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑保存
    editSave(name) {
      console.log(name)
      this.$refs.theDetail.$refs[name].validate(valid => {
        if (valid) {
          const param = {
            id: this.addForm.id,
            companyName: this.addForm.companyName,
            comNum: this.addForm.comNum,
            ignoreWord: this.addForm.ignoreWord,
            infoType: this.addForm.infoType,
            establishmentTime: this.$common.timeFormat(
              new Date(this.addForm.establishmentTime.replace(/\-/g, '/')),
              'yyyy-MM-dd'
            ),
            registeredCapital: this.addForm.registeredCapital,
            address: this.addForm.address,
            province: this.addForm.province,
            city: this.addForm.city,
            county: this.addForm.county,
            taxNature: this.addForm.taxNature,
            transferPrice: this.addForm.transferPrice,
            phone: this.addForm.phone,
            linkman: this.addForm.linkman,
            natureBusiness: this.addForm.natureBusiness,
            isPublic: this.addForm.isPublic,
            pic: this.pics,
            industries: this.addForm.industrie
          }
          this.$post('/flow/update', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.cancel()
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 返回列表
    cancel(state) {
      if (this.$route.name === 'FlowDetail') {
        this.$router.push({
          name: 'Flow'
        })
      } else {
        this.$router.push({
          name: 'FlowPublic'
        })
      }

      this.addForm = {
        id: '',
        companyName: '',
        comNum: '',
        ignoreWord: '',
        infoType: '',
        establishmentTime: '',
        registeredCapital: '',
        address: '',
        province: '',
        city: '',
        county: '',
        taxNature: '',
        transferPrice: '',
        linkman: '',
        phone: '',
        natureBusiness: '',
        isPublic: '',
        industries: [],
        industrie: []
      }
      this.picJdcmp = { src: '', file: '', name: '图片' }
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    }
    if (this.$route.params.id) {
      this.queryDetail()
    }
    this.web = this.$route.params.webState
    this.addForm.id = this.$route.params.id
    const titleName = {
      add: '新增转让公司流水',
      edit: '编辑转让公司流水',
      detail: '转让公司流水详情'
    }
    this.titles = ['转让公司流水', titleName[this.web]]
    if (this.addForm.id) {
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.edit-page,
.main-page {
  height: 100%;
}
.colspan {
  display: flex;
  span {
    flex: 1;
  }
}
.el-form-item {
  margin-bottom: 12px;
  /deep/.el-form-item__error {
    top: 85%;
  }
  /deep/.el-textarea + .el-form-item__error {
    top: 100%;
  }
}
.title {
  padding: 10px 20px;
  font-size: 18px;
}
.img-box {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 10vh;
    min-height: 10vh;
  }
  .upload {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    margin: 0 8px 8px 0;
    background-color: #f7f8fa;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
}
.img-view {
  position: relative;
  display: inline-block;
  width: 45%;
  max-width: 150px;
  height: 80px;
  margin-right: 10px;
  /deep/.el-image {
    width: 100%;
    max-height: 80px;
  }
  .btn-close {
    position: absolute;
    right: -5px;
    top: -5px;
    background-color: #fff;
    border-radius: 50%;
    color: #409eff;
    cursor: pointer;
    font-size: 16px;
  }
}
.drawer-box {
  max-height: 100vh;
  overflow: auto;
  padding: 0 8px;
}

.flow-detail {
  /deep/.el-checkbox__input.is-disabled + span.el-checkbox__label,
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner,
  /deep/.el-input.is-disabled .el-input__inner,
  /deep/.el-textarea.is-disabled .el-textarea__inner {
    color: #333;
  }
}
@media screen and (max-width: 768px) {
  .flow-detail {
    padding: 0 10px;
  }
}
</style>
